/**
 * @generated SignedSource<<73c3845e74ec792b3c4c395256f01db7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_project">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "6b9632d118257a5e9d462b11e7938daa";

export default node;
